import ReactButton from '../../../../../../components/Buttons/ReactButton';
import ReactLoader from '../../../../../../components/Loader';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import React, { useEffect, useState } from 'react';
import Pagination from 'components/Pagination';
import HourMaskMMHHSS from '../../../../../../components/Inputs/HourMaskMMHHSS.js';
import { CheckProductAvailabilityModal } from '../CheckProductAvailabilityModal';
import { SearchTable } from '../SearchTable';
import { Row, Col } from 'reactstrap';
import ProductService from '../../../../Products/service';
import { useForm, Controller } from 'react-hook-form';
import StockPerHourService from '../../../service/StockPerHourService';
import { editarProdutos } from '../../../../../../store/action/GasOrder/gasOrder.js';
import { useDispatch } from 'react-redux';

import {
  individual_column_style,
  individual_header_style
} from '../../../../../../assets/styles/table_custom_style';
import DefaultModal from 'components/Modal/DefaultModal';
import { toast } from 'react-toastify';
import CustomDatePicker from '../CustomDatePicker';

export const AddProductModalContent = ({
  data,
  setData,
  isModalOpen,
  setIsModalOpen,
  filial,
  hora,
  setHora,
  dataOportunidade,
  setDataOportunidade,
  motivo,
  selectedOpportunity
}) => {
  const { handleSubmit, control, setValue, getValues } = useForm();
  const [products, setProducts] = useState([]);
  const [productData, setProductdata] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [timeoutID, setTimeoutID] = useState(null);
  const [isModalOpenCheck, setIsModalOpenCheck] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [alteredProducts, setAlteredProducts] = useState([]);

  useEffect(() => {
    getProducts(activePage);
  }, []);

  // const handlePageChange = (activePage) => {
  //   setActivePage(activePage);
  //   getProducts(activePage);
  // };

  // const handleOnSearch = (event) => {
  //   if (typeof timeoutID === 'number') {
  //     clearTimeout(timeoutID);
  //   }
  //   const q = event;
  //   setTimeoutID(
  //     setTimeout(() => {
  //       getProducts(1, q);
  //     }, 1000)
  //   );
  // };

  const getHourlyStock = (filial, data, hora) => {
    StockPerHourService.getStockPerHour(filial, data, hora)
      .then((response) => {
        let stockInfo = response.data.data;
        let teste = productData.map((produto) => {
          if (stockInfo.length > 0) {
            for (let index = 0; index < stockInfo.length; index++) {
              if (stockInfo[index].produto === produto.name.toUpperCase()) {
                return {
                  ...produto,
                  stockPerHour: stockInfo[index].quantidadeRestante
                };
              } else if (index === stockInfo.length - 1) {
                return (produto = { ...produto, stockPerHour: 0 });
              }
            }
          } else {
            return (produto = { ...produto, stockPerHour: 0 });
          }
        });

        const options = {
          GRANEL: 0,
          P5: 1,
          P8: 2,
          P13: 3,
          P20: 4,
          P45: 5
        };

        setProductdata(teste);
      })
      .catch((err) => {
        toast.error(err.response?.data?.errors?.[0] ?? 'Ocorreu um erro!', {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const editorStyle = {
    backgroundColor: 'transparent',
    border: '1px solid #cdcdcd',
    width: '6rem',
    height: '30px',
    borderRadius: '0.25rem',
    color: '#525f7f'
  };

  async function getProducts(page, querySearch, teste) {
    const size = 10;

    setIsLoading(true);

    await ProductService.getAllSearch(false, size, page, querySearch)
      .then((res) => {
        setQuantity(res.data.totalRegisters);
        let formatedResponseData = res.data.data.map((product) => {
          let newObject = {
            ativo: product.ativo,
            code: product.codigo,
            criadoPor: product.criadoPor,
            descricao: product.descricao,
            family: product.familia,
            id: product.id,
            name: product.nome,
            value: `${product.preco == null ? 0 : product.preco}`,
            measure: product.unidadeMedida,
            discount: 0,
            amount: 0,
            entrada: 0,
            editable: false,
            disabled: false
          };

          return newObject;
        });

        let checkedData = formatedResponseData.map((produto, index) => {
          if (selectedProducts.length > 0) {
            for (let i = 0; i < selectedProducts.length; i++) {
              if (produto.id === selectedProducts[i].id) {
                return selectedProducts[i];
              } else if (i === selectedProducts.length - 1) {
                return produto;
              }
            }
          } else {
            return produto;
          }
        });

        if (motivo === '01891cf3-4d2a-4983-85ce-6b4697eb3efc') {
          let newData = checkedData.filter(
            (produto) => produto.code !== 'granel'
          );
          setProductdata(newData);
          setIsLoading(false);
          return;
        } else if (motivo === '0e02e514-e03d-41eb-be96-9434ce889885') {
          let newData = checkedData.filter(
            (produto) => produto.code === 'granel'
          );
          setProductdata(newData);
          setIsLoading(false);
          return;
        }
        setProductdata(checkedData);
        setIsLoading(false);
      })
      .catch((err) => {});
  }

  const hourRules = {
    // required: 'Campo obrigatório!',
    pattern: {
      value: /^[0-2][0-9]:[0-5][0-9]:[0-5][0-9]$/,
      message: 'Hora inválida!'
    }
  };

  const formatData = (data) => {
    let splitData = data.split('/');
    let YY = splitData[2];
    let MM = splitData[1];
    let DD = splitData[0];
    let newDataEstoque = `${YY}-${MM}-${DD}`;
    return newDataEstoque;
  };

  const handleSalvar = () => {
    let filteredAlteredProducts = alteredProducts.filter(
      (produto) => produto.amount > 0 || produto.entrada > 0
    );

    if (filteredAlteredProducts.length === 0) {
      toast.error('Por favor selecione pelo menos um produto!', {
        autoClose: 3000,
        closeOnClick: true
      });
      return;
    }

    products.map((product) => {
      if (typeof product.value == 'string') {
        product.value = parseFloat(product.value.replace(',', '.'));
      }
    });

    if (data.length === 0) {
      setData(filteredAlteredProducts);
      dispatch(
        editarProdutos({
          produtos: filteredAlteredProducts,
          index: selectedOpportunity
        })
      );
      toggleModal();
    } else {
      const fullSize = data.length + filteredAlteredProducts.length;
      const map = new Map();

      for (let index = 0; index < fullSize; index += 1) {
        if (
          filteredAlteredProducts[index] &&
          !map.has(filteredAlteredProducts[index].id)
        ) {
          map.set(
            filteredAlteredProducts[index].id,
            filteredAlteredProducts[index]
          );
        } else if (
          filteredAlteredProducts[index] &&
          map.has(filteredAlteredProducts[index].id)
        ) {
          map.set(
            filteredAlteredProducts[index].id,
            filteredAlteredProducts[index]
          );
        }
        if (data[index] && !map.has(data[index].id)) {
          map.set(data[index].id, data[index]);
        }
      }
      const result = Array.from(map.values());

      setData(result);
      dispatch(
        editarProdutos({ produtos: result, index: selectedOpportunity })
      );
      toggleModal();
    }
  };

  const handleAlteredProducts = (row, value, fieldId, fieldName) => {
    if (value > 0) {
      document.getElementById(fieldId).style.backgroundColor = '#cdcdcd';
    }

    if (value <= 0) {
      document.getElementById(fieldId).style.backgroundColor = 'transparent';
    }

    const produtoAlterado = alteredProducts.find((e) => e.id === row.id);

    if (+value === 0 && produtoAlterado) {
      let total = +produtoAlterado.entrada + +produtoAlterado.amount;
      total = total - produtoAlterado[fieldName];
      if (total > 0) {
        return;
      }
      let copyAltered = alteredProducts;
      copyAltered.splice(
        alteredProducts.findIndex((produto) => produto.id === row.id),
        1
      );
      setAlteredProducts(copyAltered);
    } else if (!produtoAlterado) {
      alteredProducts.push(row);
    }
  };

  return (
    <>
      <Row className="mb-3">
        <Col>
          <DefaultModal
            show={isModalOpenCheck}
            onModalToggle={setIsModalOpenCheck}
            title="Gás do dia"
            showCloseButton={false}
            modalContainerClasses=""
            style={{
              width: '75%',
              maxWidth: '80rem',
              height: '95%',
              maxHeight: '80rem'
            }}
          >
            <CheckProductAvailabilityModal
              isModalOpenCheck={isModalOpenCheck}
              setIsModalOpenCheck={setIsModalOpenCheck}
              filial={filial}
              data={formatData(dataOportunidade)}
            ></CheckProductAvailabilityModal>
          </DefaultModal>

          <Row className="mb-3">
            <Col md="6">
              <label className="form-control-label">Data</label>

              <CustomDatePicker
                disabled={data.length > 0 ? true : false}
                fieldName="dataEstoque"
                valueController={(fieldname, value) => {
                  setValue(fieldname, value);
                  // setDataEstoque(formatData(data));
                  setDataOportunidade(value);
                }}
                defaultValue={dataOportunidade}
              />
            </Col>
            <Col md="6">
              <label className="form-control-label">Hora</label>
              <Controller
                render={(props) => (
                  <HourMaskMMHHSS
                    disabled={data.length > 0 ? true : false}
                    valueController={(fieldName, value) => {
                      setValue(fieldName, value);
                      setHora(value);
                    }}
                    fieldName="timeStart"
                    value={props.value}
                  />
                )}
                control={control}
                name="timeStart"
                rules={hourRules}
                defaultValue={hora}
              />
            </Col>
            <Col md="12">
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '1rem 0',
                  marginRight: '-1rem'
                }}
              >
                <ReactButton
                  btnColor="confirmation"
                  onClick={() => {
                    setIsModalOpenCheck(true);
                  }}
                >
                  Verificar Gás do Dia
                </ReactButton>
                <ReactButton
                  btnColor="confirmation"
                  onClick={() => {
                    getHourlyStock(filial, formatData(dataOportunidade), hora);
                  }}
                >
                  Estoque da Hora
                </ReactButton>
              </div>
            </Col>
          </Row>

          <ToolkitProvider
            data={productData}
            keyField="uuid"
            columns={[
              {
                dataField: 'code',
                text: 'CODE',
                editable: false,
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style
              },
              {
                dataField: 'name',
                text: 'NAME',
                editable: false,
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style
              },
              // {
              //   dataField: 'family',
              //   text: 'FAMÍLIA',
              //   editable: false,
              //   sort: true,
              //   style: individual_column_style,
              //   headerStyle: individual_header_style
              // },
              {
                dataField: 'stockPerHour',
                text: 'ESTOQUE',
                editable: false,
                sort: true,
                style: individual_column_style,
                headerStyle: individual_header_style
              },
              {
                dataField: 'amount',
                text: 'QUANTIDADE',
                sort: true,
                style: individual_column_style,
                headerStyle: { ...individual_header_style, width: '6rem' },

                formatter: (cellContent, row, value) => {
                  return (
                    <input
                      style={editorStyle}
                      id={`${value}.amount.modal`}
                      defaultValue={cellContent}
                      onBlur={(event) => {
                        if (event.target.value === '') {
                          document.getElementById(
                            `${value}.amount.modal`
                          ).value = '0';
                        }
                      }}
                      onChange={(event) => {
                        handleAlteredProducts(
                          row,
                          event.target.value,
                          event.target.id,
                          'amount'
                        );
                        let formatedNumber = document
                          .getElementById(`${value}.amount.modal`)
                          .value.replace(/\D/g, '');

                        document.getElementById(`${value}.amount.modal`).value =
                          formatedNumber;
                        if (!formatedNumber) {
                          formatedNumber = 0;
                        }
                        row.amount = formatedNumber;
                      }}
                    />
                  );
                }
              },
              {
                dataField: 'entrada',
                text: 'ENTRADA',
                sort: true,
                style: individual_column_style,
                headerStyle: { ...individual_header_style, width: '6rem' },

                formatter: (cellContent, row, value) => {
                  return (
                    <input
                      style={editorStyle}
                      id={`${value}.entrada.modal`}
                      defaultValue={0}
                      onBlur={(event) => {
                        if (event.target.value === '') {
                          document.getElementById(
                            `${value}.entrada.modal`
                          ).value = '0';
                        }
                      }}
                      onChange={(event) => {
                        handleAlteredProducts(
                          row,
                          event.target.value,
                          event.target.id,
                          'entrada'
                        );
                        let formatedNumber = document
                          .getElementById(`${value}.entrada.modal`)
                          .value.replace(/\D/g, '');

                        document.getElementById(
                          `${value}.entrada.modal`
                        ).value = formatedNumber;
                        if (!formatedNumber) {
                          formatedNumber = 0;
                        }
                        row.entrada = formatedNumber;
                      }}
                    />
                  );
                }
              }
            ]}
          >
            {(props) => (
              <div className="py-4 table-responsive">
                {/* <SearchTable handleOnSearch={handleOnSearch} /> */}

                <Row
                  style={{
                    display: `${isLoading ? 'flex' : 'none'}`,
                    justifyContent: 'center'
                  }}
                  className="justify-content-md-center"
                >
                  <ReactLoader />
                </Row>

                <div
                  style={{ display: `${isLoading ? 'none' : 'initial'}` }}
                  className="py-4 table-responsive"
                >
                  <BootstrapTable
                    {...props.baseProps}
                    bootstrap4={true}
                    keyField="id"
                    bordered={false}
                    classes="align-items-center"
                    noDataIndication="Nenhum produto encontrado"
                  />
                </div>
              </div>
            )}
          </ToolkitProvider>
        </Col>
      </Row>
      {/* <Row className="md-3" style={{ justifyContent: 'center' }}>
        <Pagination
          activePage={activePage}
          totalItemsCount={quantity}
          onChange={handlePageChange.bind(this)}
        />
      </Row> */}

      <Row className="md-3" style={{ marginLeft: '0.938rem' }}>
        <ReactButton
          btnColor="confirmation"
          onClick={() => {
            handleSalvar();
          }}
        >
          Salvar
        </ReactButton>
        <ReactButton
          btnColor="cancelation"
          onClick={() => {
            toggleModal();
          }}
        >
          Cancelar
        </ReactButton>
      </Row>
    </>
  );
};
